import {useMemo} from 'react';
import isDevelopment from 'utils/development';

/**
 * Returns the overlay container element.
 * The overlay container should already be setup on the Hats side.
 */
const useOverlayContainer = (): HTMLElement =>
    useMemo(() => {
        // For nested z-dropdown overlays in Storybook
        if (document.querySelector('.z-dropdown')) {
            return [...document.querySelectorAll('.z-dropdown > div')].slice(
                -1,
            )[0] as HTMLElement;
        }
        // If we are in development, we can just use the body element.
        // This is mostly used for Vitest.
        if (isDevelopment()) return document.body;

        const reactOverlay = document.querySelector(
            '#react-overlays',
        ) as HTMLElement | null;
        if (!reactOverlay)
            throw new Error(
                "React overlay container not found, is there an element with the id 'react-overlays' in the document?",
            );
        if (!reactOverlay?.shadowRoot)
            throw new Error(
                'React overlay container does not have a shadow root, is the shadow dom enabled?',
            );
        const innerDiv = reactOverlay.shadowRoot.querySelector(
            '#wrapper',
        ) as HTMLElement | null;
        if (!innerDiv)
            throw new Error(
                'React overlay container does not have a wrapper div',
            );

        // For nested z-dropdown overlays in production
        if (innerDiv.querySelector('.z-dropdown')) {
            return [...innerDiv.querySelectorAll('.z-dropdown > div')].slice(
                -1,
            )[0] as HTMLElement;
        }

        return innerDiv;
    }, []);

export default useOverlayContainer;
